interface Filho {
  nivel: number;
}

interface Item {
  procuraId?: number;
  origemProcura?: string;
  filhos: Filho[];
}

type ContagemNiveis = Record<number, number>;

const getChaveProcura = (item: Item) =>
  `${item.origemProcura || "SEM_ORIGEM"}-${item.procuraId || 0}`;

// Funcao para contar niveis agrupando por procura unica em cada nivel
export const contarNiveis = (dados: Item[]): ContagemNiveis => {
  const contagem: ContagemNiveis = {};
  const niveisPorProcura = new Map<string, Set<number>>();

  dados.forEach((item) => {
    const chaveProcura = getChaveProcura(item);
    const niveisUnicos = niveisPorProcura.get(chaveProcura) || new Set<number>();

    item.filhos.forEach((filho) => {
      if (filho.nivel !== undefined && filho.nivel !== null) {
        niveisUnicos.add(filho.nivel);
      }
    });

    niveisPorProcura.set(chaveProcura, niveisUnicos);
  });

  niveisPorProcura.forEach((niveis) => {
    niveis.forEach((nivel) => {
      contagem[nivel] = (contagem[nivel] || 0) + 1;
    });
  });

  return contagem;
};
